import React from 'react'
import { Mail, Shield, FileText } from 'lucide-react'

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-16">
      <div className="container-width section-padding">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-primary-600 rounded-lg flex items-center justify-center">
              <Mail className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-white">AI 최전선 뉴스레터</h3>
          </div>
          
          <p className="text-gray-400 max-w-2xl mx-auto leading-relaxed">
            글로벌 AI 커뮤니티의 최신 인사이트를 매주 요약하여 전달하는 
            프리미엄 뉴스레터 서비스입니다.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <h4 className="text-lg font-bold text-white mb-4">서비스 정보</h4>
            <ul className="space-y-2 text-sm">
              <li>매주 화요일 발송</li>
              <li>5분 완독 가능</li>
              <li>15개 해외 커뮤니티 분석</li>
              <li>완벽한 한국어 번역</li>
            </ul>
          </div>
          
          <div className="text-center">
            <h4 className="text-lg font-bold text-white mb-4">구독 혜택</h4>
            <ul className="space-y-2 text-sm">
              <li>실전 AI 툴 가이드 (무료)</li>
              <li>구독자 전용 콘텐츠</li>
              <li>AI 트렌드 예측 리포트</li>
              <li>언제든 구독 취소 가능</li>
            </ul>
          </div>
          
          <div className="text-center">
            <h4 className="text-lg font-bold text-white mb-4">고객 지원</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="mailto:support@turings.co.kr" className="hover:text-primary-400 transition-colors">
                  support@turings.co.kr
                </a>
              </li>
              <li>24시간 내 답변 보장</li>
              <li>구독 취소 즉시 처리</li>
              <li>개인정보 완벽 보호</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-6 text-sm">
              <a 
                href="/terms" 
                className="flex items-center gap-2 hover:text-primary-400 transition-colors"
              >
                <FileText className="w-4 h-4" />
                이용약관
              </a>
              <a 
                href="/privacy" 
                className="flex items-center gap-2 hover:text-primary-400 transition-colors"
              >
                <Shield className="w-4 h-4" />
                개인정보보호
              </a>
            </div>
            
            <div className="text-sm text-gray-500">
              © 2024 주식회사 튜링스. All rights reserved.
            </div>
          </div>
        </div>

        <div className="text-center mt-8 pt-8 border-t border-gray-800">
          <p className="text-xs text-gray-500 max-w-4xl mx-auto leading-relaxed">
            본 뉴스레터는 공개된 해외 커뮤니티 정보를 수집, 분석하여 제공하는 서비스입니다. 
            모든 정보는 참고용이며, 투자나 사업 결정에 대한 책임은 구독자 본인에게 있습니다. 
            AI 기술 발전에 따라 서비스 내용이 변경될 수 있으며, 
            중요한 변경사항은 사전에 공지하겠습니다.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
